// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ActivityDot-dot-29Dgz {\n  height: 6px;\n  width: 6px;\n  margin-left: 2px;\n  background-color: #0071d4;\n  border-radius: 50%;\n  display: inline-flex;\n  vertical-align: top;\n}\n", ""]);
// Exports
exports.locals = {
	"dot": "ActivityDot-dot-29Dgz"
};
module.exports = exports;
